import React, { useState } from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useProfileStore } from '../../../store/profileStore';
import { Profile } from '../../../store/profileStore';
import { useThemeStore } from '../../../store/themeStore';
import Dropdown from '../../common/Dropdown';
import ListItem from '../../common/ListItem';
import SubAlarmEditor from '../fields/SubAlarmEditor';

const ProfilesSettings: React.FC = () => {
    const { selectedTheme } = useThemeStore();
    const { profiles, activeProfileId, setActiveProfile, addProfile, removeProfile } = useProfileStore();
    const [newName, setNewName] = useState('');

    const activeProfile = profiles.find((p) => p.id === activeProfileId);

    const handleCreate = () => {
        const name = newName.trim() || 'New Profile';
        const newProfile: Profile = {
            id: `profile-${crypto.randomUUID()}`,
            name,
            themeId: selectedTheme.id,
            totalMinutes: 10,
            subAlarms: [],
        };
        addProfile(newProfile);
        setActiveProfile(newProfile.id);
        setNewName('');
    };

    const profileOptions = [
        { label: '✨ Plain Timer', value: '__none__' },
        ...profiles.map((p) => ({ label: p.name, value: p.id })),
    ];

    const profileSwitcher = (
        <div className="flex w-full flex-col gap-2">
            <div className="text-lg">Active Profile</div>
            <Dropdown
                options={profileOptions}
                selectedValue={activeProfileId || '__none__'}
                currentTheme={selectedTheme}
                onChange={(id) => setActiveProfile(id === '__none__' ? null : id)}
                buttonBorderColor={selectedTheme.color.point}
            />
            {activeProfile && (
                <p className="text-xs opacity-60">
                    {activeProfile.totalMinutes} min · {activeProfile.subAlarms.length} sub-alarms
                </p>
            )}
        </div>
    );

    return (
        <div>
            <h3 className="text-lg font-semibold">Profiles</h3>
            <div className="mt-6 space-y-6">
                <ListItem icon={<IoMdAdd size={24} className="size-full" />} content={profileSwitcher} />

                {activeProfile && (
                    <>
                        <ListItem
                            icon={<IoMdAdd size={24} className="size-full" />}
                            content={
                                <div className="flex w-full flex-col gap-2">
                                    <span className="text-lg">Profile Name & Duration</span>
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="text"
                                            value={activeProfile.name}
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                useProfileStore.getState().updateProfile(activeProfile.id, { name: v });
                                            }}
                                            className="w-full rounded border px-2 py-1 text-sm text-black"
                                        />
                                        <input
                                            type="number"
                                            min={1}
                                            max={60}
                                            value={activeProfile.totalMinutes}
                                            onChange={(e) => {
                                                const v = Number(e.target.value) || 1;
                                                useProfileStore
                                                    .getState()
                                                    .updateProfile(activeProfile.id, { totalMinutes: v });
                                            }}
                                            className="w-16 rounded border px-2 py-1 text-sm text-black"
                                        />
                                        <span className="text-sm">min</span>
                                    </div>
                                </div>
                            }
                        />

                        <SubAlarmEditor profile={activeProfile} />

                        {activeProfile.id !== 'profile-morning-routine' && activeProfile.id !== 'profile-exam' && (
                            <button
                                onClick={() => {
                                    removeProfile(activeProfile.id);
                                }}
                                className="text-sm text-red-500 underline"
                            >
                                Delete this profile
                            </button>
                        )}
                    </>
                )}

                <ListItem
                    icon={<IoMdAdd size={24} className="size-full" />}
                    content={
                        <div className="flex w-full items-center gap-2">
                            <input
                                type="text"
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                                placeholder="New profile name…"
                                className="w-full rounded border px-2 py-1 text-sm text-black"
                            />
                            <button
                                onClick={handleCreate}
                                className="shrink-0 rounded px-3 py-1 text-sm font-semibold"
                                style={{ backgroundColor: selectedTheme.color.point, color: '#fff' }}
                            >
                                Add
                            </button>
                        </div>
                    }
                />
            </div>
        </div>
    );
};

export default ProfilesSettings;
